/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Contingent } from './contingent';
import { FeatureConfig } from './featureConfig';
import { RoleResponse } from './roleResponse';

export interface StateConfig { 
    projectRunningIfcChecksData?: Array<string>;
    projectRunningQualityChecksData?: Array<string>;
    projectRunningBimBaseChecksData?: Array<string>;
    runningClassifications?: Array<string>;
    featureConfigs?: Array<FeatureConfig>;
    contingent?: Contingent;
    organisations?: { [key: string]: RoleResponse; };
    projects?: { [key: string]: RoleResponse; };
    globalPrivileges?: Array<StateConfig.GlobalPrivilegesEnum>;
    stage?: StateConfig.StageEnum;
    hoaiDefinitionId?: string;
    loiplusDefinitionId?: string;
}
export namespace StateConfig {
    export type GlobalPrivilegesEnum = 'PROJECT_VIEWER' | 'PROJECT_SETTINGS' | 'PROJECT_USER_MANAGEMENT' | 'PROJECT_FILE_EDIT' | 'PROJECT_FILE_DELETE' | 'PROJECT_TASK_EDIT' | 'PROJECT_TASK_DELETE' | 'PROJECT_CHECK_EXECUTE' | 'PROJECT_MYCHECK_MANAGE' | 'PROJECT_MYCHECK_DELETE' | 'PROJECT_CHECKRULE_MANAGE' | 'PROJECT_CHECKRULE_DELETE' | 'PROJECT_HOAI_CHECK' | 'PROJECT_QUALITY_CHECK' | 'PROJECT_BIM_TOOLS_CHECK' | 'PROJECT_SHOP' | 'ORGANISATION_VIEWER' | 'ORGANISATION_SETTINGS' | 'ORGANISATION_USER_MANAGEMENT' | 'ORGANISATION_PROJECT_EDIT' | 'ORGANISATION_PROJECT_DELETE' | 'ORGANISATION_VIEW_ALL_PROJECTS' | 'ORGANISATION_SHOP' | 'GLOBAL_CHECKRULE_ADMIN';
    export const GlobalPrivilegesEnum = {
        PROJECTVIEWER: 'PROJECT_VIEWER' as GlobalPrivilegesEnum,
        PROJECTSETTINGS: 'PROJECT_SETTINGS' as GlobalPrivilegesEnum,
        PROJECTUSERMANAGEMENT: 'PROJECT_USER_MANAGEMENT' as GlobalPrivilegesEnum,
        PROJECTFILEEDIT: 'PROJECT_FILE_EDIT' as GlobalPrivilegesEnum,
        PROJECTFILEDELETE: 'PROJECT_FILE_DELETE' as GlobalPrivilegesEnum,
        PROJECTTASKEDIT: 'PROJECT_TASK_EDIT' as GlobalPrivilegesEnum,
        PROJECTTASKDELETE: 'PROJECT_TASK_DELETE' as GlobalPrivilegesEnum,
        PROJECTCHECKEXECUTE: 'PROJECT_CHECK_EXECUTE' as GlobalPrivilegesEnum,
        PROJECTMYCHECKMANAGE: 'PROJECT_MYCHECK_MANAGE' as GlobalPrivilegesEnum,
        PROJECTMYCHECKDELETE: 'PROJECT_MYCHECK_DELETE' as GlobalPrivilegesEnum,
        PROJECTCHECKRULEMANAGE: 'PROJECT_CHECKRULE_MANAGE' as GlobalPrivilegesEnum,
        PROJECTCHECKRULEDELETE: 'PROJECT_CHECKRULE_DELETE' as GlobalPrivilegesEnum,
        PROJECTHOAICHECK: 'PROJECT_HOAI_CHECK' as GlobalPrivilegesEnum,
        PROJECTQUALITYCHECK: 'PROJECT_QUALITY_CHECK' as GlobalPrivilegesEnum,
        PROJECTBIMTOOLSCHECK: 'PROJECT_BIM_TOOLS_CHECK' as GlobalPrivilegesEnum,
        PROJECTSHOP: 'PROJECT_SHOP' as GlobalPrivilegesEnum,
        ORGANISATIONVIEWER: 'ORGANISATION_VIEWER' as GlobalPrivilegesEnum,
        ORGANISATIONSETTINGS: 'ORGANISATION_SETTINGS' as GlobalPrivilegesEnum,
        ORGANISATIONUSERMANAGEMENT: 'ORGANISATION_USER_MANAGEMENT' as GlobalPrivilegesEnum,
        ORGANISATIONPROJECTEDIT: 'ORGANISATION_PROJECT_EDIT' as GlobalPrivilegesEnum,
        ORGANISATIONPROJECTDELETE: 'ORGANISATION_PROJECT_DELETE' as GlobalPrivilegesEnum,
        ORGANISATIONVIEWALLPROJECTS: 'ORGANISATION_VIEW_ALL_PROJECTS' as GlobalPrivilegesEnum,
        ORGANISATIONSHOP: 'ORGANISATION_SHOP' as GlobalPrivilegesEnum,
        GLOBALCHECKRULEADMIN: 'GLOBAL_CHECKRULE_ADMIN' as GlobalPrivilegesEnum
    };
    export type StageEnum = 'dev' | 'beta' | 'live';
    export const StageEnum = {
        Dev: 'dev' as StageEnum,
        Beta: 'beta' as StageEnum,
        Live: 'live' as StageEnum
    };
}